import state from './fleets.state'
import mutations from './fleets.mutations'
import actions from './fleets.actions'
import getters from './fleets.getters'

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
